import React from 'react'
import './MentionsLegales.css';

const MentionsLegales: React.FC = () => {
    return (
        <div className="mentions-legales-page">
            <div className="mentions-legales-container">
                <h1 className="mentions-legales-title-h1">Mentions légales</h1>

                <h2 className="mentions-legales-title-h2">Centralis® - Centrale d’achat public dédiée à la rénovation de patrimoine</h2>
                <p className="mentions-legales-paragraph">
                    Centralis est une association loi 1901 à but non lucratif enregistrée sous le N°W273007926 et le SIRET 893 375 386 00016,
                    dont le siège social est situé au 229 Rue Saint-Honoré, 75001 Paris 1er.
                </p>
                <p className="mentions-legales-paragraph">
                    Coordonnées bancaires : IBAN FR76 1830 6000 1036 1080 3648 091 - BIC AGRIFRPP883
                </p>

                <h3 className="mentions-legales-title-h3">Directeur de la publication</h3>
                <p className="mentions-legales-paragraph">
                    Jérôme TACONNET – Président de Centralis
                </p>

                <h3 className="mentions-legales-title-h3">Protection des droits</h3>
                <p className="mentions-legales-paragraph">
                    Le contenu de ce site, développé par Centralis ou pour son compte, est protégé par la législation applicable en matière de
                    droit d’auteur, de droit des marques, de droit des dessins et modèles et de concurrence déloyale.
                </p>
                <p className="mentions-legales-paragraph">
                    Il comprend notamment l’architecture, la charte graphique, ainsi que l’ensemble des informations et éléments disponibles sur
                    le site (textes, articles, photographies, illustrations, images, marques, logos, bases de données, sons et vidéos, programmes téléchargeables, etc.).
                </p>
                <p className="mentions-legales-paragraph">
                    Toute reproduction, représentation, diffusion ou exploitation de tout ou partie du contenu, par quelque moyen que ce soit,
                    est interdite sans autorisation expresse écrite de Centralis. La source (site Centralis) et l’auteur doivent toujours être mentionnés.
                </p>
                <p className="mentions-legales-paragraph">
                    Toute personne ne respectant pas ces dispositions se rend coupable de contrefaçon et s’expose à des sanctions pénales.
                </p>

                <h3 className="mentions-legales-title-h3">Responsabilités</h3>
                <p className="mentions-legales-paragraph">
                    Centralis exclut toute garantie quant au contenu, y compris toute garantie de qualité, d’adéquation à un usage particulier,
                    de propriété ou d’absence de contrefaçon. Centralis ne saurait être tenue responsable de dommages directs ou indirects
                    résultant de l’utilisation du site ou de son contenu.
                </p>
                <p className="mentions-legales-paragraph">
                    Les liens externes présents sur le site sont fournis à titre informatif et ne constituent pas une approbation.
                    Centralis n’exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu, produits ou services.
                </p>
                <p className="mentions-legales-paragraph">
                    Les marques, noms de produits ou sociétés mentionnés demeurent la propriété de leurs titulaires respectifs.
                </p>

                <h3 className="mentions-legales-title-h3">Confidentialité</h3>
                <p className="mentions-legales-paragraph">
                    Pour des besoins de statistiques et d’affichage, le site <a href="https://www.centralis-europe.com/" target="_blank" rel="noopener noreferrer">www.centralis-europe.com</a> utilise des cookies permettant d’enregistrer des informations sur votre navigation.
                </p>
                <p className="mentions-legales-paragraph">
                    Conformément à la loi n°78-17 du 6 janvier 1978 relative à l’informatique, aux fichiers et aux libertés,
                    toute personne ayant déposé sur le site des informations nominatives peut en demander communication ou rectification.
                </p>

                <h3 className="mentions-legales-title-h3">Hébergeur</h3>
                <p className="mentions-legales-paragraph">
                    L’hébergement du site est assuré par Scaleway, domicilié au 8 Rue de la Ville l’Évêque, 75008 Paris,
                    représenté par son Président Damien Lucas.
                </p>

                <h3 className="mentions-legales-title-h3">Cookies</h3>
                <p className="mentions-legales-paragraph">
                    Lors de la consultation du site, des informations relatives à votre navigation peuvent être enregistrées dans des fichiers « cookies »
                    installés sur votre terminal, selon vos choix modifiables à tout moment.
                </p>
                <p className="mentions-legales-paragraph">
                    Pour plus d’informations, consultez le site de la CNIL : <a href="https://www.cnil.fr/vos-droits/vos-traces/les-cookies" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>.
                </p>

                <h4 className="mentions-legales-title-h4">Définition</h4>
                <p className="mentions-legales-paragraph">
                    Un cookie est un petit fichier texte enregistré sur votre terminal (ordinateur, tablette, smartphone) lors de la visite d’un site.
                    Il contient des données (nom du serveur, identifiant unique, date d’expiration) et sert à mémoriser vos préférences de navigation.
                </p>

                {/* <h4 className="mentions-legales-title-h4">Types de cookies utilisés</h4>
                <ul className="mentions-legales-list">
                    <li><strong>Cookies nécessaires :</strong> indispensables au bon fonctionnement du site. Exemple : <em>has_js</em> (vérifie si JavaScript est activé, durée : session).</li>
                    <li><strong>Cookies statistiques :</strong> permettent d’optimiser le fonctionnement du site et d’établir des statistiques anonymes de fréquentation.</li>
                </ul> */}
                <p className="mentions-legales-paragraph">
                    Vous pouvez configurer votre navigateur pour refuser tout ou partie des cookies. Cependant, certaines pages du site pourraient ne pas s’afficher correctement.
                </p>
            </div>
        </div>
    )
}

export default MentionsLegales